/**
 * App navigation flow to different places of template
 * @module App-Navigation-Routes
 */

import { Route, Routes } from "react-router-dom";
import { route } from "../globals/constants";

import HomeRoutes from "./home-routes";
import ServicesRoutes from "./services-routes";
import BlogRoutes from "./blog-routes";

// Import page components directly
import AboutUsPage from "../app/components/pages/about";
import CaseStudyPage from "../app/components/pages/case-study";
import ContactUsPage from "../app/components/pages/contact";
import FAQPage from "../app/components/pages/faq";
import OurTeamPage from "../app/components/pages/team";
import PrivacyPolicyPage from "../app/pages/pages/privacy-policy";
import TermsOfServicePage from "../app/pages/pages/terms-of-service";
import CookiePolicyPage from "../app/pages/pages/cookie-policy";
import AcceptableUsePolicyPage from "../app/pages/pages/acceptable-use-policy";
import DataBreachPolicyPage from "../app/pages/pages/data-breach-policy";
import BusinessContinuityPolicyPage from "../app/pages/pages/business-continuity-policy";
import EmployeeCodeOfConductPage from "../app/pages/pages/employee-code-of-conduct";
import ProjectDetailPage from "../app/pages/pages/project-detail";
import BlogsDetailPage from "../app/components/blogs/blogs-detail";

/**
 * @returns - Describes navigation for different menus of Template Header:
 ** {@link HomeRoutes | Home Menu}
 ** {@link ServicesRoutes | Services Menu}
 ** {@link BlogRoutes | Blog Menu}
 */
const AppRoutes = () => {
    return (
        <Routes>
            {/* Services routes */}
            <Route path={route.services.INITIAL+"/*"} element={<ServicesRoutes />}/>
            
            {/* Blog routes */}
            <Route path={route.blogs.INITIAL+"/*"} element={<BlogRoutes />}/>
            
            {/* Pages routes (now at root level) */}
            <Route path="/about-us" element={<AboutUsPage />}/>
            <Route path="/contact-us" element={<ContactUsPage />}/>
            <Route path="/success-stories/:projectId" element={<ProjectDetailPage />}/>
            <Route path="/success-stories" element={<CaseStudyPage />}/>
            <Route path="/blog/:blogId" element={<BlogsDetailPage />}/>
            <Route path="/faq" element={<FAQPage />}/>
            <Route path="/our-team" element={<OurTeamPage />}/>
            <Route path="/privacy-policy" element={<PrivacyPolicyPage />}/>
            <Route path="/terms-of-service" element={<TermsOfServicePage />}/>
            <Route path="/cookie-policy" element={<CookiePolicyPage />}/>
            <Route path="/acceptable-use-policy" element={<AcceptableUsePolicyPage />}/>
            <Route path="/data-breach-policy" element={<DataBreachPolicyPage />}/>
            <Route path="/business-continuity-policy" element={<BusinessContinuityPolicyPage />}/>
            <Route path="/employee-code-of-conduct" element={<EmployeeCodeOfConductPage />}/>
            
            {/* Home routes (catch remaining routes) */}
            <Route path="*" element={<HomeRoutes />}/>
        </Routes>
    )
}
export default AppRoutes;